// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see P2PAllowListViewStartEvent
 */
export var P2PAllowListViewStart = function (_a) {
    var subjectCustomerToken = _a.subjectCustomerToken;
    return ({
        name: "P2PAllowList View Start",
        parameters: {
            cdf_entity: "P2PAllowList",
            cdf_action: "View",
            subject_customer_token: subjectCustomerToken !== undefined && subjectCustomerToken !== null ? subjectCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see P2PAllowListEditStartEvent
 */
export var P2PAllowListEditStart = function (_a) {
    var subjectCustomerToken = _a.subjectCustomerToken, targetCustomerToken = _a.targetCustomerToken, action = _a.action;
    return ({
        name: "P2PAllowList Edit Start",
        parameters: {
            cdf_entity: "P2PAllowList",
            cdf_action: "Edit",
            subject_customer_token: subjectCustomerToken !== undefined && subjectCustomerToken !== null ? subjectCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            target_customer_token: targetCustomerToken !== undefined && targetCustomerToken !== null ? targetCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
